/* @flow strict */

import * as React from 'react';
import DropZone from '/client/src/components/dropZone';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { POST } from '/client/src/api';
import NProgressCustom from '/client/src/components/nProgress';
import CssPinner from '/client/src/components/csspinner';
import SectionHeader from './SectionHeader';
import _ from 'lodash';

import './PhotoStyles.scss';

const arrayMove = require('array-move');

type PropsType = {
  onHandleChangePhotos: () => void,
  editablePart?: any,
  eventDetail: {
    image_crop_info: {
      x1: number,
      x2: number,
      y1: number,
      y2: number
    }
  }
};

class Photos extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      files: _.get(props, 'editablePart.files', []),
      link_label: _.get(props, 'editablePart.link_label', 'Photos'),
      addToNav: _.get(props, 'editablePart.addToNav', true),
      background_color: _.get(props, 'editablePart.background_color', 'Light')
    };
  }

  handleMoveFiles = (currentIndex: number, direction: string) => {
    let _direction = currentIndex;

    if (direction === 'left') {
      _direction = currentIndex - 1;
    } else {
      _direction = currentIndex + 1;
    }

    const { files } = this.state;
    const newFiles = arrayMove(files, currentIndex, _direction);

    this.setState({
      files: newFiles
    });

    this.props.onHandleChangePhotos({
      files: newFiles
    });
  };

  handleRemoveFile = (url: string) => {
    const { files } = this.state;
    const newFiles = _.remove(files, (f: {}): boolean => {
      return f.url !== url;
    });

    this.setState({
      files: newFiles
    });

    this.props.onHandleChangePhotos({
      files: newFiles
    });
  };

  uploadImg = async (file: File, id: number, callback: () => void): {} => {
    const dropZoneWrapper = document.querySelector('.dropCropZone');
    const merchantId = _.get(this.context.profileCurrent, 'id');
    const formData = new FormData();

    formData.append('FileName[0]', file);

    try {
      NProgressCustom(true);
      CssPinner(dropZoneWrapper, true);

      const { result } = await POST(`/api/v1/1/assets/upload/${merchantId}`, formData, null, 'multipart/form-data', null, true);

      NProgressCustom(false);
      CssPinner(dropZoneWrapper, false);

      return callback(result[0].url, id);
    } catch (e) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Image upload failed'
      });
      NProgressCustom(false);
      CssPinner(dropZoneWrapper, false);
      console.log(e);
      return false;
    }
  };

  handleDrop = async (acceptedFiles: any, fileRejections: any) => {
    if (_.size(fileRejections)) {
      this.context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: fileRejections[0].errors[0].code === 'file-too-large' ? 'File is too large.' : 'Image upload failed'
      });
    }

    acceptedFiles.forEach((file: File, index: number) => {
      const reader = new FileReader();

      reader.onabort = (): any => console.log('file reading was aborted');
      reader.onerror = (): any => console.log('file reading has failed');
      reader.onload = () => {
        const binaryStr = reader.result;

        const newFiles = [
          ...this.state.files,
          {
            url: binaryStr,
            temp_id: index,
            loading: true
          }
        ];

        this.setState({
          files: newFiles
        });
      };

      reader.readAsDataURL(file);

      const callbackUpload = (_url: string, _id: number) => {
        const newFiles = this.state.files;

        const uploadedFileIndex = newFiles.findIndex(x => x.temp_id === _id);

        newFiles[uploadedFileIndex] =
          {
            ...newFiles[uploadedFileIndex],
            loading: false,
            url: _url,
            temp_id: -1
          };

        this.setState({
          files: newFiles
        });

        this.props.onHandleChangePhotos({
          files: newFiles
        });

        return true;
      };

      this.uploadImg(file, index, callbackUpload).then((result) => {
         if (!result) {
           const newFiles = this.state.files;

           const removeIndex = newFiles.findIndex(x => x.temp_id === -1);

           newFiles.splice(removeIndex, 1);

           this.setState({
             files: newFiles
           });
         }
      });
    });
  };

  render(): React.Element<typeof React.Fragment> {
    const {
      files
    } = this.state;

    const {
      editablePart,
      eventDetail: image_crop_info
    } = this.props;

    return (
      <>
        <SectionHeader
          {...this.props}
          onHandleChange={this.props.onHandleChangePhotos}
          title={_.get(editablePart, 'link_label') || 'Photos'}
        />

        <div className="row">
          <div className="col-xs-12">
            <div className="dropCropZone">
              <DropZone
                onDrop={this.handleDrop}
                onlyImages
                image_crop_info={image_crop_info}
              />
            </div>
          </div>

          <div className="col-xs-12">
            <ul className='PhotosPreview'>
              {_.map(files, (f: {}, fi: number): React.Element<'li'> => (
                <li key={`img-${fi}`} >
                <i
                  className='glyphicon glyphicon-remove remove'
                  onClick={() => {
                    this.handleRemoveFile(f.url);
                  }}
                />
                {fi !== 0 &&
                  <i
                    className="glyphicon glyphicon-chevron-left moveLeft"
                    onClick={() => {
                      this.handleMoveFiles(fi, 'left');
                    }}
                  />
                }

                {(_.size(files) > 1 && (fi + 1) !== _.size(files)) &&
                  <i
                    className="glyphicon glyphicon-chevron-right moveRight"
                    onClick={() => {
                      this.handleMoveFiles(fi, 'right');
                    }}
                  />
                }
                <img src={f.url} alt="image"/>
              <div className={f.loading ? 'preview-photo-loading csspinner' : ''} />
              </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  }
}

export default Photos;
